import { WBFlex } from '@admiin-com/ds-web';

import { WBLinkButton } from '@admiin-com/ds-web';
import { useTranslation } from 'react-i18next';
import { MobileDocumentDrawer } from './MobileDocumentDrawer';
import { useState } from 'react';
import { useTheme, useMediaQuery } from '@mui/material';

export const MobilePdfViewLink = ({
  documentUrl,
  annotations,
}: {
  documentUrl: string;
  annotations?: any;
}) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  if (!isMobile) {
    return null;
  }
  return (
    <WBFlex mt={2}>
      <WBLinkButton onClick={() => setOpen(true)} color="primary.main">
        {t('View document')}
      </WBLinkButton>
      <MobileDocumentDrawer
        documentUrl={documentUrl}
        open={open}
        onClose={() => setOpen(false)}
        annotations={annotations}
      />
    </WBFlex>
  );
};
